import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './nav.css';
import { StaticQuery, graphql, Link } from 'gatsby';
// import { FiHome } from 'react-icons/fi';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { IoIosMenu, IoIosClose } from 'react-icons/io';
import { Location } from '@reach/router';

class SiteNav extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.currentLocation = [];
    this.state = {
      isOpen: false,
    };
  }

  disableScrolling(open) {
    if (typeof document === 'undefined') {
      return false;
    }
    // Disables scrolling when the modal is open, as suggested by
    // https://www.w3.org/TR/2017/NOTE-wai-aria-practices-1.1-20171214/examples/dialog-modal/dialog.html
    if (open) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    }
  }

  toggle() {
    this.disableScrolling(!this.state.isOpen);

    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  renderDropdownMenuItem(page, index, menuItemList) {
    let { selectedLanguage, menuItems } = this.props;

    let isMainActive = this.currentLocation.includes(page.url);
    menuItems
      .filter(item => item.parent && item.parent === page.url)
      .forEach(subPage => {
        isMainActive =
          isMainActive || this.currentLocation.includes(subPage.url);
      });

    return (
      <UncontrolledDropdown
        nav
        key={page.url}
      > {index === menuItemList.length - 1 && menuItemList.length > 1 && (
        <div>DropDown</div>
      )}
        <DropdownToggle nav caret>
          <Link
          onClick={() => { window.__navigatingToLink = true; }}
            tag="span"
            to={`/${selectedLanguage}/${page.url}`}
          >
            {page.menuTitle}
          </Link>
        </DropdownToggle>
          <DropdownMenu>
            {menuItems
              .filter(item => item.parent && item.parent === page.url)
              .map(subPage => (
                <DropdownItem
                onClick={() => { window.__navigatingToLink = true; }}
                  tag="a"
                  className={
                    this.currentLocation.includes(subPage.url) ? 'active' : ''
                  }
                  href={`/${selectedLanguage}/${subPage.url}`}
                  key={page.url + subPage.url}
                >
                  {subPage.menuTitle}
                </DropdownItem>
              ))}
          </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  renderSimpleMenuItem(page, index) {
    let { selectedLanguage } = this.props;

    const onlyActives = this.currentLocation.slice(1, 3);
    const isActive = onlyActives.includes(page.url);

    return (
      <NavItem key={index}>
        {page.url === '' ? (
          <Link
          onClick={() => { window.__navigatingToLink = true; }}
            to={`/${selectedLanguage}/${page.url}`}
            className={(isActive ? 'active ' : '') + ' home'}
          >
            <img src={'/images/home-icon-w.png'} alt={'Home'} className={(isActive ? 'active ' : '') + ' home-img'}/>
          </Link>
        ) : (
          <Link
          onClick={() => { window.__navigatingToLink = true; }}
            to={`/${selectedLanguage}/${page.url}`}
            className={
              (isActive ? 'active ' : '') +
              (page.url === 'trial-search' ? ' last' : '')
            }
          >
            {page.menuTitle}
          </Link>
        )}
      </NavItem>
    );
  }

  renderItem(page, index, menuItemList) {
    let { menuItems } = this.props;

    // check if is simple or with submenu
    const hasSubmenu = menuItems.filter(
      item => item.parent && item.parent === page.url
    ).length;

    if (hasSubmenu) {
      return this.renderDropdownMenuItem(page, index, menuItemList);
    }

    return this.renderSimpleMenuItem(page, index, menuItemList);
  }

  render() {
    return (
      <Container>
        <Location>
          {({ location }) => {
            let { menuItems, hideSearch } = this.props;

            this.currentLocation = location.pathname.split('/');

            return (
              <Navbar expand="md">
                {menuItems.length > 2 &&
                  (this.state.isOpen === false ? (
                    <NavbarToggler onClick={() => {this.toggle(); hideSearch()}}>
                      <IoIosMenu className={'burger'} />
                    </NavbarToggler>
                  ) : (
                    <NavbarToggler onClick={this.toggle}>
                      <IoIosClose className={'close'} />
                    </NavbarToggler>
                  ))
                }
                <Collapse
                  className={'collapse navbar-collapse'}
                  id="navbarCollapse"
                  isOpen={menuItems.length > 2 ? this.state.isOpen : true}
                  navbar
                >
                  <Nav className="navBar-ul" navbar>
                    {menuItems
                      .filter(
                        page =>
                          typeof page.parent === 'undefined' ||
                          page.parent === null
                      )
                      .map(this.renderItem.bind(this))}
                  </Nav>
                </Collapse>
              </Navbar>
            );
          }}
        </Location>
      </Container>
    );
  }
}

const NavWithQuery = props => (
  <StaticQuery
    query={graphql`
      query {
        pageMetadataJson {
          pages {
            menuTitle
            url
            pageLang
          }
        }
      }
    `}
    render={data => <SiteNav data={data} {...props} />}
  />
);

export default NavWithQuery;

SiteNav.propTypes = {
  data: PropTypes.object.isRequired,
  selectedLanguage: PropTypes.any.isRequired,
  menuItems: PropTypes.array.isRequired,
  hideSearch: PropTypes.any
};
